
import ImagesLoaded from 'Imagesloaded'

(function($){

  $.fn.scrollCenter = function(elem, speed) {

    // this = #timepicker
    // elem = .active

    var active = $(this).find(elem); // find the active element
    //var activeWidth = active.width(); // get active width
    var activeWidth = active.width() / 2; // get active width center

    var pos = active.position().left + activeWidth; //get left position of active li + center position
    var elpos = $(this).scrollLeft(); // get current scroll position
    var elW = $(this).width(); //get div width
    //var divwidth = $(elem).width(); //get div width
    pos = pos + elpos - elW / 2; // for center position if you want adjust then change this

    $(this).animate({
      scrollLeft: pos
    }, speed == undefined ? 1000 : speed);
    return this;
  };

  $(document).ready(function(){

    if( $('.sevices-nav').length ) {
      $('.sevices-nav ul').singlePageNav({
        offset:  $(window).outerWidth() > 991 ? 112 : 102,
        //filter: ':not(.open-link)',
        updateHash: false,
        currentClass: 'is-active',
        onComplete: function() {
          $('.sevices-nav').scrollCenter('.is-active', 300);
        }
        // speed: 400,
        // easing: 'easeOutQuart',
      });
      
      ImagesLoaded('body', ()=> {
        const goto = $('[data-goto]').data('goto')
  
        if (goto) {
          
          $('html,body').animate({
            scrollTop: $('#' + goto).offset().top - ( $(window).outerWidth() > 991 ? 111 : 101 ),
          }, {
            duration: 800,
            complete: () => {
              setTimeout(() => { 
                $('.sevices-nav').scrollCenter('.is-active', 300);
              }, 200);
            }
          });
        }
      })
    }
  });

})($);
